/**
 * Webpack-bundled Mitra dashboard thumbs (same files as Flutter
 * locsy_mitra/assets/images/dashboard). Guarantees images ship in the
 * React build — not dependent on public/ deploy alone.
 */

import catalog_manager from './catalog_manager.webp';
import ad_campaigns from './ad_campaigns.webp';
import deals_coupons_card from './deals_coupons_card.webp';
import announcements_card from './announcements_card.webp';
import customer_leads from './customer_leads.webp';
import business_details_card from './business_details_card.webp';
import photos_update_card from './photos_update_card.webp';
import stock from './stock.webp';
import new_bill_card from './new_bill_card.webp';
import new_bill_card_png from './new_bill_card.png';
import draft_bills_card from './draft_bills_card.webp';
import view_bills_card from './view_bills_card.webp';
import pending_works from './pending_works.webp';
import quick_billing_card from './quick_billing_card.webp';
import catalog_billing_card from './catalog_billing_card.webp';
import service_billing_card from './service_billing_card.webp';
import create_bill_card from './create_bill_card.webp';
import user_postings from './user_postings.webp';
import citizen_posting_categories from './citizen_posting_categories.webp';
import today_sales from './today_sales.webp';
import leads_stats_card from './leads_stats_card.webp';
import digital_attendance from './digital_attendance.webp';
import quick_add_product from './quick_add_product.webp';
import quick_create_ad from './quick_create_ad.webp';
import quick_add_coupon from './quick_add_coupon.webp';
import quick_shop_photos from './quick_shop_photos.webp';
import grow_business_banner from './grow_business_banner.webp';
import customers from './customers.webp';
import expenses from './expenses.webp';
import shop_polls_card from './shop_polls_card.png';
import loksy_wallet_card from './loksy_wallet_card.png';
import shop_orders_card from './shop_orders_card.png';
import live_kitchen_tokens_card from './live_kitchen_tokens_card.png';
import token_board_settings_card from './token_board_settings_card.png';
import order_recycle_bin_card from './order_recycle_bin_card.png';
import order_token_reports_card from './order_token_reports_card.png';
import shop_upi_card from './shop_upi_card.png';

/** filename → bundled URL */
export const MITRA_BUNDLED_WEBP = {
  'catalog_manager.webp': catalog_manager,
  'ad_campaigns.webp': ad_campaigns,
  'deals_coupons_card.webp': deals_coupons_card,
  'announcements_card.webp': announcements_card,
  'customer_leads.webp': customer_leads,
  'business_details_card.webp': business_details_card,
  'photos_update_card.webp': photos_update_card,
  'stock.webp': stock,
  'new_bill_card.webp': new_bill_card,
  'new_bill_card.png': new_bill_card_png,
  'draft_bills_card.webp': draft_bills_card,
  'view_bills_card.webp': view_bills_card,
  'pending_works.webp': pending_works,
  'quick_billing_card.webp': quick_billing_card,
  'catalog_billing_card.webp': catalog_billing_card,
  'service_billing_card.webp': service_billing_card,
  'create_bill_card.webp': create_bill_card,
  'user_postings.webp': user_postings,
  'citizen_posting_categories.webp': citizen_posting_categories,
  'today_sales.webp': today_sales,
  'leads_stats_card.webp': leads_stats_card,
  'digital_attendance.webp': digital_attendance,
  'quick_add_product.webp': quick_add_product,
  'quick_create_ad.webp': quick_create_ad,
  'quick_add_coupon.webp': quick_add_coupon,
  'quick_shop_photos.webp': quick_shop_photos,
  'grow_business_banner.webp': grow_business_banner,
  'customers.webp': customers,
  'expenses.webp': expenses,
  'shop_polls_card.png': shop_polls_card,
  'loksy_wallet_card.png': loksy_wallet_card,
  'shop_orders_card.png': shop_orders_card,
  'live_kitchen_tokens_card.png': live_kitchen_tokens_card,
  'token_board_settings_card.png': token_board_settings_card,
  'order_recycle_bin_card.png': order_recycle_bin_card,
  'order_token_reports_card.png': order_token_reports_card,
  'shop_upi_card.png': shop_upi_card,
};

/** Stable card_key → default filename (matches Flutter DashboardFeatureAssets). */
export const MITRA_CARD_KEY_TO_ASSET = {
  grow_catalog_manager: 'catalog_manager.webp',
  grow_ad_campaigns: 'ad_campaigns.webp',
  grow_my_ads: 'ad_campaigns.webp',
  grow_deals_coupons: 'quick_add_coupon.webp',
  grow_shop_spin: 'deals_coupons_card.webp',
  op_user_guide: 'business_details_card.webp',
  op_faq: 'customer_leads.webp',
  op_print_cards: 'catalog_manager.webp',
  grow_announcements: 'announcements_card.webp',
  grow_customer_leads: 'customer_leads.webp',
  grow_shop_polls: 'shop_polls_card.png',
  grow_loksy_wallet: 'loksy_wallet_card.png',
  op_loksy_wallet: 'loksy_wallet_card.png',
  grow_shop_orders: 'shop_orders_card.png',
  grow_token_board: 'live_kitchen_tokens_card.png',
  grow_token_board_settings: 'token_board_settings_card.png',
  grow_shop_recycle_bin: 'order_recycle_bin_card.png',
  grow_shop_orders_reports: 'order_token_reports_card.png',
  grow_shop_upi: 'shop_upi_card.png',
  grow_token_locsy_ads: 'quick_create_ad.webp',
  grow_business_details: 'business_details_card.webp',
  grow_photos_update: 'photos_update_card.webp',
  op_services_catalog: 'catalog_manager.webp',
  op_main_categories: 'catalog_manager.webp',
  op_billing_catalog: 'catalog_manager.webp',
  op_inventory_stock: 'stock.webp',
  op_purchases: 'stock.webp',
  op_expenses: 'expenses.webp',
  op_dues: 'customers.webp',
  op_street_vendor_live: 'customers.webp',
  op_new_bill: 'new_bill_card.png',
  op_draft_bills: 'draft_bills_card.webp',
  op_view_bills: 'view_bills_card.webp',
  op_pending_works: 'pending_works.webp',
  op_whatsapp_messages: 'customer_leads.webp',
  op_shop_spin: 'deals_coupons_card.webp',
  op_coupons: 'deals_coupons_card.webp',
  op_enquiry_form: 'customer_leads.webp',
  op_locsy_leads: 'customer_leads.webp',
  op_citizen_requirements_inbox: 'customer_leads.webp',
  op_user_postings: 'user_postings.webp',
  op_citizen_posting_categories: 'citizen_posting_categories.webp',
  op_today_sales: 'today_sales.webp',
  op_leads_stats: 'leads_stats_card.webp',
  op_digital_attendance: 'digital_attendance.webp',
};
